import useResolvedProperties from "./useResolvedProperties";
import NodePositionContainer from "./NodePositionContainer";
import useSelectedFigureItems from "./useSelectedFigureItems";

import NodeDropPoints from "./NodeDropPoints";
import NodePositionChangeDispatcher from './NodePositionChangeDispatcher';
import NodeResizer from "./NodeResizer";

import { useCallback, useState, useContext, useRef, useMemo } from 'react';
import { useDispatch, useStore } from 'react-redux';
import { DragInterfaceContext } from './MouseDragProvider';
import A from './ActionCreators';
import getChangesByCellLocation from './getChangesByCellLocation';

import useEditorDispatch from './useEditorDispatch';
import { GridCellContext } from './Contexts';
import { useFigurePanelId } from './FigurePanelIdProvider';
import NodeWrapper from './NodeWrapper';
import { WidthResizeContext, NodeBoundsContext } from './Contexts';
import { nodeEq } from './utils';
import nodesThatShouldChange from './nodesThatShouldChange';
import G from './Getters';

function findNode(nodeLocator,nodeList=[]){
  return nodeList.find(node => nodeEq(nodeLocator,node));
}


export default function NodePositioner({
  children, 
  position, 
  nodeId, 
  node,
  style,
  parentBox,
  interactive,
}){


  ;

  const renderCounter = useRef(0);
  renderCounter.current++;

  

  let cellLocation = useContext(GridCellContext);
  const selectedFigureItems = useSelectedFigureItems()

  const figurePanelId = useFigurePanelId();
  const dispatch = useDispatch();
  const store = useStore();

  const [ _tempPosition, setTempPosition ] = useState();
  const tempPositionRef = useRef(_tempPosition);
  const {setChanges} = useContext(NodeBoundsContext);

  const editorDispatch = useEditorDispatch();
  let thisNodeLocator = {cellLocation,nodeId}; 


  
  const resolvedProperties = useResolvedProperties(
    thisNodeLocator,
    {location:position},
  )
  let resolvedPosition = resolvedProperties.location;



  const dragInterface = useContext(DragInterfaceContext);
 


  const [dragging,setDragging] = useState();
  
  const [ delta, setDelta] = useState({dw:0,dh:0});


 
  const onNodeDragStart = useMemo(() => {
    let renderCount = renderCounter.current;
    return (e)=>{


      e.stopPropagation();
      e.preventDefault();

      let targetLocations = nodesThatShouldChange(
        thisNodeLocator,
        selectedFigureItems?.expansionNodes || [],
        store.getState(),
        figurePanelId
      );

      dragInterface?.startDrag?.({
        event:e,
        onMouseMove:(start,end,info) => {


          let deltaY = Math.abs(end[1] - start[1]);
          let deltaX = Math.abs(end[0] - start[0]);

          if( deltaY > 2 || deltaX > 2 ){
            setDragging(true); 
          }else{
            setDragging(false);
          }
        },
        onDragEnd:(start,end,info,mouseEvent) => {

          let { targetLocations } = info;
          let isDragging = tempPositionRef.current;




          if( !isDragging ){
            mouseEvent.stopPropagation();
            setDragging(false);
            setTempPosition();
            setChanges();

            editorDispatch && editorDispatch({

              type:"click",
              itemType:"expansionNode",
              cellLocation,
              //node,
              event:e,
              nodeId,
            })
            return;
          }else if( isDragging ){

            

            let location = tempPositionRef.current.value.location;
            //let tl = tempPositionRef.current?.changeTargets?.expansionNodes;

            let byCellLocation = getChangesByCellLocation({
              targetLocations,
              properties:{
                "location":location,
              }
            });

            dispatch(A.setCellsValueProperties({
              figurePanelId,
              byCellLocation

            }))


            setDragging(false);
            setTempPosition();
            tempPositionRef.current = null;
            setChanges();
          }
        },
        targetLocations,

      })

    }





  },[setDragging,selectedFigureItems]);

  const onClick = useMemo(() => {
   
    return e => {

      

      debugger;

      e.stopPropagation();
      e.preventDefault();


      !dragging && editorDispatch && editorDispatch({

        type:e.type,
        itemType:"expansionNode",
        cellLocation,
        //node,
        event:e,
        nodeId,


      })
    }
  },[cellLocation,nodeId,dragging])


  const onMouseDown = useMemo(() => {
    return e => {

    e.stopPropagation();
    e.preventDefault();

    

    editorDispatch && editorDispatch({

      type:"click",//e.type,
      itemType:"expansionNode",
      cellLocation,
      //node,
      event:e,
      nodeId,
    })
    }
  },[cellLocation,nodeId])


  let nodeComponent = useMemo(() => (
      <div onMouseDown={onNodeDragStart} nodeId={nodeId} item={"container"} style={{
        position:'relative',
        margin:style.margin,
        padding:style.padding,
        zIndex:1000,
        //pointerEvents:'auto',
        outline:`${style?.borderWidth}px solid ${style?.borderColor}`,

        pointerEvents:(interactive?'auto':'none'),

      }} 

        ref={() => {
        }}

        onClick={e => {
          e.preventDefault();
          e.stopPropagation();
        }}
        //onMouseDown={onMouseDown}
        onContextMenu={onClick}
        class="clickable sg-row outline-on-hover">

        
        {/*
          We may get a double outline
          if we have an inset region
          Or the region is close to the size
          of the parent node...

*/}
        <WidthResizeContext.Provider value={delta}>
          {children}
        </WidthResizeContext.Provider>

        {interactive && <NodeWrapper node={node} nodeId={nodeId}/>}
      </div>

  ),[style,onNodeDragStart,nodeId,onMouseDown,onClick,children,delta])


  let component;
  if( interactive ){
    component = (
      <NodeResizer {...{
        setChanges,
        node,
        parentBox,
        cellLocation,
        nodeId,
        nodePositionDragging:dragging,

      }}>
        {nodeComponent}
      </NodeResizer>
    )
  }else{
    component = nodeComponent;
  }



  


  let flexBoxWrapped = (
    <NodePositionContainer position={resolvedPosition}>
      {component}
    </NodePositionContainer>

  )



  return (
    <>

      {flexBoxWrapped}


      {dragging && <NodePositionChangeDispatcher {...{
        nodeId,
        cellLocation,
        selected:selectedFigureItems,

      }}
        nodeId={nodeId} onChange={v => {

          tempPositionRef.current = v;
          setChanges(v)

        }}/>}





    </>
  )

}






